/**
 * 充电订单 | 充值订单 | 占位订单 | 追款订单 | 换电柜订单 | 分账订单 | 金额变动 | 分账流水
 */
import Net from '../net';

const NAME = '[OrderApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === Order === **/
/** order/list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.page
 * @param {*} data.sn
 * @param {*} data.outer_sn
 * @param {*} data.socket_uid
 * @param {*} data.gateway_uid
 * @param {*} data.nickname
 * @param {*} data.user_phone
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.device_type
 * @param {*} data.status
 * @param {*} data.pay_method
 * @param {*} data.clearing_status
 * @param {*} data.finish_code
 * @param {*} data.power_mode
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.clearing_begin_time
 * @param {*} data.clearing_end_time
 * @param {*} data.finish_begin_time
 * @param {*} data.finish_end_time
 * @param {*} data.license_plate_number
 * @param {*} data.flag_booking
 * @param {*} data.vin
 * @param {*} data.user_id
 * @param {*} data.refund_begin_time
 * @param {*} data.refund_end_time
*/
export async function getOrderList(data = {}) {
  Log('getOrderList data:', data)
  try {
    const res = await Net.http('order/list', { data })
    Log('getOrderList res:', res)
    return res
  } catch (err) {
    Log('getOrderList err:', err)
    throw err
  }
}

/** order/pre-order-list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.page
 * @param {*} data.sn
 * @param {*} data.outer_sn
 * @param {*} data.socket_uid
 * @param {*} data.gateway_uid
 * @param {*} data.nickname
 * @param {*} data.user_phone
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.device_type
 * @param {*} data.status
 * @param {*} data.pay_method
 * @param {*} data.clearing_status
 * @param {*} data.finish_code
 * @param {*} data.power_mode
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.clearing_begin_time
 * @param {*} data.clearing_end_time
 * @param {*} data.finish_begin_time
 * @param {*} data.finish_end_time
 * @param {*} data.license_plate_number
 * @param {*} data.flag_booking
 * @param {*} data.vin
 * @param {*} data.user_id
*/
export async function orderPrecontractList(data = {}) {
  Log('orderPrecontractList data:', data)
  try {
    const res = await Net.http('order/pre-order-list', { data })
    Log('orderPrecontractList res:', res)
    return res
  } catch (err) {
    Log('orderPrecontractList err:', err)
    throw err
  }
}

/** order/history-order-list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.page
 * @param {*} data.sn
 * @param {*} data.outer_sn
 * @param {*} data.socket_uid
 * @param {*} data.gateway_uid
 * @param {*} data.nickname
 * @param {*} data.user_phone
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.device_type
 * @param {*} data.status
 * @param {*} data.pay_method
 * @param {*} data.clearing_status
 * @param {*} data.finish_code
 * @param {*} data.power_mode
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.clearing_begin_time
 * @param {*} data.clearing_end_time
 * @param {*} data.finish_begin_time
 * @param {*} data.finish_end_time
 * @param {*} data.license_plate_number
 * @param {*} data.flag_booking
 * @param {*} data.vin
 * @param {*} data.user_id
 * @param {*} data.refund_begin_time
 * @param {*} data.refund_end_time
*/
export async function orderHistoryList(data = {}) {
  Log('orderHistoryList data:', data)
  try {
    const res = await Net.http('order/history-order-list', { data })
    Log('orderHistoryList res:', res)
    return res
  } catch (err) {
    Log('orderHistoryList err:', err)
    throw err
  }
}

/** pursue-order/power-order-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.socket_uid
 * @param {*} data.gateway_uid
 * @param {*} data.nickname
 * @param {*} data.user_phone
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.device_type
 * @param {*} data.power_outer_sn
 * @param {*} data.power_order_sn
*/
export async function orderPursueList(data = {}) {
  Log('orderPursueList data:', data)
  try {
    const res = await Net.http('pursue-order/power-order-list', { data })
    Log('orderPursueList res:', res)
    return res
  } catch (err) {
    Log('orderPursueList err:', err)
    throw err
  }
}

/** order/detail
 * @param {Object} data
 * @param {*} data.order_id
*/
export async function getOrderDetail(data = {}) {
  Log('getOrderDetail data:', data)
  try {
    const res = await Net.http('order/detail', { data })
    Log('getOrderDetail res:', res)
    return res
  } catch (err) {
    Log('getOrderDetail err:', err)
    throw err
  }
}

/** order/getByChargeTransactionId
 * @param {Object} data
 * @param {*} data.charge_transaction_id
*/
export async function getOrderDetailByChargeTransactionId(data = {}) {
  Log('getOrderDetailByChargeTransactionId data:', data)
  try {
    const res = await Net.http('order/getByChargeTransactionId', { data })
    Log('getOrderDetailByChargeTransactionId res:', res)
    return res
  } catch (err) {
    Log('getOrderDetailByChargeTransactionId err:', err)
    throw err
  }
}

/** order/refund
 * @param {Object} data
 * @param {*} data.order_sn
*/
export async function orderRefund(data = {}) {
  Log('orderRefund data:', data)
  try {
    const res = await Net.http('order/refund', { data })
    Log('orderRefund res:', res)
    return res
  } catch (err) {
    Log('orderRefund err:', err)
    throw err
  }
}

/** order/refund-after-clearing
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.clearing_config_id
 * @param {*} data.money
 * @param {*} data.time
*/
export async function orderRefundAfterClearing(data = {}) {
  Log('orderRefundAfterClearing data:', data)
  try {
    const res = await Net.http('order/refund-after-clearing', { data })
    Log('orderRefundAfterClearing res:', res)
    return res
  } catch (err) {
    Log('orderRefundAfterClearing err:', err)
    throw err
  }
}

/** order/hello-order-refund
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.clearing_config_id
 * @param {*} data.refund_money
*/
export async function orderRefundHaLuo(data = {}) {
  Log('orderRefundHaLuo data:', data)
  try {
    const res = await Net.http('order/hello-order-refund', { data })
    Log('orderRefundHaLuo res:', res)
    return res
  } catch (err) {
    Log('orderRefundHaLuo err:', err)
    throw err
  }
}

/** order/refund-custom-money
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.money
*/
export async function orderRefundCustom(data = {}) {
  Log('orderRefundCustom data:', data)
  try {
    const res = await Net.http('order/refund-custom-money', { data })
    Log('orderRefundCustom res:', res)
    return res
  } catch (err) {
    Log('orderRefundCustom err:', err)
    throw err
  }
}

/** order/cancel-payscore-order
 * @param {Object} data
 * @param {*} data.id
*/
export async function orderPayScoreCancel(data = {}) {
  Log('orderPayScoreCancel data:', data)
  try {
    const res = await Net.http('order/cancel-payscore-order', { data })
    Log('orderPayScoreCancel res:', res)
    return res
  } catch (err) {
    Log('orderPayScoreCancel err:', err)
    throw err
  }
}

/** order/update-order-status
 * @param {Object} data
 * @param {*} data.order_id
*/
export async function orderCompelFinish(data = {}) {
  Log('orderCompelFinish data:', data)
  try {
    const res = await Net.http('order/update-order-status', { data })
    Log('orderCompelFinish res:', res)
    return res
  } catch (err) {
    Log('orderCompelFinish err:', err)
    throw err
  }
}

/** order/test-time-over
 * @param {Object} data
 * @param {*} data.order_id
*/
export async function orderFinishOverTime(data = {}) {
  Log('orderFinishOverTime data:', data)
  try {
    const res = await Net.http('order/test-time-over', { data })
    Log('orderFinishOverTime res:', res)
    return res
  } catch (err) {
    Log('orderFinishOverTime err:', err)
    throw err
  }
}

/** action/list-by-order-id
 * @param {Object} data
 * @param {*} data.target_id
*/
export async function getOrderActionList(data = {}) {
  Log('getOrderActionList data:', data)
  try {
    const res = await Net.http('action/list-by-order-id', { data })
    Log('getOrderActionList res:', res)
    return res
  } catch (err) {
    Log('getOrderActionList err:', err)
    throw err
  }
}

/** device-power-record/list
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.page
*/
export async function getOrderPowerRecord(data = {}) {
  Log('getOrderPowerRecord data:', data)
  try {
    const res = await Net.http('device-power-record/list', { data })
    Log('getOrderPowerRecord res:', res)
    return res
  } catch (err) {
    Log('getOrderPowerRecord err:', err)
    throw err
  }
}

/** device-power-record/power-log
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.page
*/
export async function getOrderPowerRecordV2(data = {}) {
  Log('getOrderPowerRecordV2 data:', data)
  try {
    const res = await Net.http('device-power-record/power-log', { data })
    Log('getOrderPowerRecordV2 res:', res)
    return res
  } catch (err) {
    Log('getOrderPowerRecordV2 err:', err)
    throw err
  }
}

/** device-power-record/get-last-power-log
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.page
*/
export async function getOrderLastPowerLog(data = {}) {
  Log('getOrderLastPowerLog data:', data)
  try {
    const res = await Net.http('device-power-record/get-last-power-log', { data })
    Log('getOrderLastPowerLog res:', res)
    return res
  } catch (err) {
    Log('getOrderLastPowerLog err:', err)
    throw err
  }
}

/** order/manual-clearing-order
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.order_type
*/
export async function orderManualClearing(data = {}) {
  Log('orderManualClearing data:', data)
  try {
    const res = await Net.http('order/manual-clearing-order', { data })
    Log('orderManualClearing res:', res)
    return res
  } catch (err) {
    Log('orderManualClearing err:', err)
    throw err
  }
}

/** order/manual-clearing-order/batch
 * @param {Object} data
 * @param {*} data.order_ids
 * @param {*} data.order_type
*/
export async function orderBatchManualClearing(data = {}) {
  Log('orderBatchManualClearing data:', data)
  try {
    const res = await Net.http('order/manual-clearing-order/batch', { data })
    Log('orderBatchManualClearing res:', res)
    return res
  } catch (err) {
    Log('orderBatchManualClearing err:', err)
    throw err
  }
}

/** export-task/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.type
 * @param {*} data.status
*/
export async function exportOrderList(data = {}) {
  Log('exportOrderList data:', data)
  try {
    const res = await Net.http('export-task/list', { data })
    Log('exportOrderList res:', res)
    return res
  } catch (err) {
    Log('exportOrderList err:', err)
    throw err
  }
}

/** ml-order-pred/detail
 * @param {Object} data
 * @param {*} data.order_id
*/
export async function getOrderLabel(data = {}) {
  Log('getOrderLabel data:', data)
  try {
    const res = await Net.http('ml-order-pred/detail', { data })
    Log('getOrderLabel res:', res)
    return res
  } catch (err) {
    Log('getOrderLabel err:', err)
    throw err
  }
}

/** ml-order-pred/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.order_id
 * @param {*} data.order_report
 * @param {*} data.label
*/
export async function setOrderLabel(data = {}) {
  Log('setOrderLabel data:', data)
  try {
    const res = await Net.http('ml-order-pred/save', { data })
    Log('setOrderLabel res:', res)
    return res
  } catch (err) {
    Log('setOrderLabel err:', err)
    throw err
  }
}

/** order/close-pre-order
 * @param {Object} data
 * @param {*} data.sn
*/
export async function closeOrderPreOrder(data = {}) {
  Log('closeOrderPreOrder data:', data)
  try {
    const res = await Net.http('order/close-pre-order', { data })
    Log('closeOrderPreOrder res:', res)
    return res
  } catch (err) {
    Log('closeOrderPreOrder err:', err)
    throw err
  }
}

/** order/pre-order-refund
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.clearing_config_id
 * @param {*} data.money
*/
export async function orderPreOrderRefund(data = {}) {
  Log('orderPreOrderRefund data:', data)
  try {
    const res = await Net.http('order/pre-order-refund', { data })
    Log('orderPreOrderRefund res:', res)
    return res
  } catch (err) {
    Log('orderPreOrderRefund err:', err)
    throw err
  }
}

/** occupy-order/detail-by-charge-order-id
 * @param {Object} data
 * @param {*} data.order_id
*/
export async function orderOccupyDetailByChargeOrderId(data = {}) {
  Log('orderOccupyDetailByChargeOrderId data:', data)
  try {
    const res = await Net.http('occupy-order/detail-by-charge-order-id', { data })
    Log('orderOccupyDetailByChargeOrderId res:', res)
    return res
  } catch (err) {
    Log('orderOccupyDetailByChargeOrderId err:', err)
    throw err
  }
}


/** === RechargeOrder === **/
/** charge-order/list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.order_sn
 * @param {*} data.outer_sn
 * @param {*} data.user_name
 * @param {*} data.user_phone
 * @param {*} data.clearing_status
 * @param {*} data.charge_type
 * @param {*} data.status
 * @param {*} data.pay_method
 * @param {*} data.card_uid
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.refund_begin_time
 * @param {*} data.refund_end_time
*/
export async function getRechargeOrderList(data = {}) {
  Log('getRechargeOrderList data:', data)
  try {
    const res = await Net.http('charge-order/list', { data })
    Log('getRechargeOrderList res:', res)
    return res
  } catch (err) {
    Log('getRechargeOrderList err:', err)
    throw err
  }
}

/** charge-order/list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.page
 * @param {*} data.pay_method
 * @param {*} data.card_uid
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getRechargeOrderListByCard(data = {}) {
  Log('getRechargeOrderListByCard data:', data)
  try {
    const res = await Net.http('charge-order/list', { data })
    Log('getRechargeOrderListByCard res:', res)
    return res
  } catch (err) {
    Log('getRechargeOrderListByCard err:', err)
    throw err
  }
}

/** charge-order/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getRechargeOrderDetail(data = {}) {
  Log('getRechargeOrderDetail data:', data)
  try {
    const res = await Net.http('charge-order/detail', { data })
    Log('getRechargeOrderDetail res:', res)
    return res
  } catch (err) {
    Log('getRechargeOrderDetail err:', err)
    throw err
  }
}

/** charge-order/detail-sn
 * @param {Object} data
 * @param {*} data.pay_sn
*/
export async function getRechargeOrderDetailByPaySn(data = {}) {
  Log('getRechargeOrderDetailByPaySn data:', data)
  try {
    const res = await Net.http('charge-order/detail-sn', { data })
    Log('getRechargeOrderDetailByPaySn res:', res)
    return res
  } catch (err) {
    Log('getRechargeOrderDetailByPaySn err:', err)
    throw err
  }
}

/** charge-order/charge-order-refund
 * @param {Object} data
 * @param {*} data.sn
 * @param {*} data.clearing_config_id
 * @param {*} data.money
 * @param {*} data.ticket_id
*/
export async function rechargeOrderRefundAfterClearing(data = {}) {
  Log('rechargeOrderRefundAfterClearing data:', data)
  try {
    const res = await Net.http('charge-order/charge-order-refund', { data })
    Log('rechargeOrderRefundAfterClearing res:', res)
    return res
  } catch (err) {
    Log('rechargeOrderRefundAfterClearing err:', err)
    throw err
  }
}

/** charge-order/charge-order-refund
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.money
*/
export async function rechargeOrderRefundCustom(data = {}) {
  Log('rechargeOrderRefundCustom data:', data)
  try {
    const res = await Net.http('charge-order/charge-order-refund', { data })
    Log('rechargeOrderRefundCustom res:', res)
    return res
  } catch (err) {
    Log('rechargeOrderRefundCustom err:', err)
    throw err
  }
}

/** charge-order/manual-clearing-order
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.order_type
*/
export async function rechargeOrderManualClearing(data = {}) {
  Log('rechargeOrderManualClearing data:', data)
  try {
    const res = await Net.http('charge-order/manual-clearing-order', { data })
    Log('rechargeOrderManualClearing res:', res)
    return res
  } catch (err) {
    Log('rechargeOrderManualClearing err:', err)
    throw err
  }
}

/** export-task/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.type
 * @param {*} data.status
*/
export async function exportRechargeOrderList(data = {}) {
  Log('exportRechargeOrderList data:', data)
  try {
    const res = await Net.http('export-task/list', { data })
    Log('exportRechargeOrderList res:', res)
    return res
  } catch (err) {
    Log('exportRechargeOrderList err:', err)
    throw err
  }
}


/** === OccupyOrder === **/
/** occupy-order/list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.page
 * @param {*} data.sn
 * @param {*} data.outer_sn
 * @param {*} data.socket_uid
 * @param {*} data.gateway_uid
 * @param {*} data.nickname
 * @param {*} data.user_phone
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.status
 * @param {*} data.pay_method
 * @param {*} data.clearing_status
 * @param {*} data.finish_code
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.create_begin_time
 * @param {*} data.create_end_time
 * @param {*} data.clearing_begin_time
 * @param {*} data.clearing_end_time
 * @param {*} data.user_id
*/
export async function getOccupyOrderList(data = {}) {
  Log('getOccupyOrderList data:', data)
  try {
    const res = await Net.http('occupy-order/list', { data })
    Log('getOccupyOrderList res:', res)
    return res
  } catch (err) {
    Log('getOccupyOrderList err:', err)
    throw err
  }
}

/** occupy-order/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getOccupyOrderDetail(data = {}) {
  Log('getOccupyOrderDetail data:', data)
  try {
    const res = await Net.http('occupy-order/detail', { data })
    Log('getOccupyOrderDetail res:', res)
    return res
  } catch (err) {
    Log('getOccupyOrderDetail err:', err)
    throw err
  }
}

/** occupy-order/refund-after-clearing
 * @param {Object} data
 * @param {*} data.occupy_order_sn
 * @param {*} data.clearing_config_id
 * @param {*} data.money
*/
export async function occupyOrderRefundAfterClearing(data = {}) {
  Log('occupyOrderRefundAfterClearing data:', data)
  try {
    const res = await Net.http('occupy-order/refund-after-clearing', { data })
    Log('occupyOrderRefundAfterClearing res:', res)
    return res
  } catch (err) {
    Log('occupyOrderRefundAfterClearing err:', err)
    throw err
  }
}

/** occupy-order/refund-gate-order-after-clearing
 * @param {Object} data
 * @param {*} data.occupy_order_sn
 * @param {*} data.clearing_config_id
 * @param {*} data.money
*/
export async function occupyOrderRefundGateAfterClearing(data = {}) {
  Log('occupyOrderRefundGateAfterClearing data:', data)
  try {
    const res = await Net.http('occupy-order/refund-gate-order-after-clearing', { data })
    Log('occupyOrderRefundGateAfterClearing res:', res)
    return res
  } catch (err) {
    Log('occupyOrderRefundGateAfterClearing err:', err)
    throw err
  }
}

/** occupy-order/manual-clearing-order
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.order_type
*/
export async function occupyOrderManualClearing(data = {}) {
  Log('occupyOrderManualClearing data:', data)
  try {
    const res = await Net.http('occupy-order/manual-clearing-order', { data })
    Log('occupyOrderManualClearing res:', res)
    return res
  } catch (err) {
    Log('occupyOrderManualClearing err:', err)
    throw err
  }
}

/** occupy-order/query-order-by-device
 * @param {Object} data
 * @param {*} data.suid
 * @param {*} data.port_index
*/
export async function queryOccupyOrderOrderByDevice(data = {}) {
  Log('queryOccupyOrderOrderByDevice data:', data)
  try {
    const res = await Net.http('occupy-order/query-order-by-device', { data })
    Log('queryOccupyOrderOrderByDevice res:', res)
    return res
  } catch (err) {
    Log('queryOccupyOrderOrderByDevice err:', err)
    throw err
  }
}


/** === PursueOrder === **/
/** pursue-order/list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.page
 * @param {*} data.sn
 * @param {*} data.outer_sn
 * @param {*} data.socket_uid
 * @param {*} data.gateway_uid
 * @param {*} data.nickname
 * @param {*} data.user_phone
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.status
 * @param {*} data.pay_method
 * @param {*} data.clearing_status
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.clearing_begin_time
 * @param {*} data.clearing_end_time
 * @param {*} data.user_id
 * @param {*} data.occupy_order_sn
*/
export async function getPursueOrderList(data = {}) {
  Log('getPursueOrderList data:', data)
  try {
    const res = await Net.http('pursue-order/list', { data })
    Log('getPursueOrderList res:', res)
    return res
  } catch (err) {
    Log('getPursueOrderList err:', err)
    throw err
  }
}

/** pursue-order/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getPursueOrderDetail(data = {}) {
  Log('getPursueOrderDetail data:', data)
  try {
    const res = await Net.http('pursue-order/detail', { data })
    Log('getPursueOrderDetail res:', res)
    return res
  } catch (err) {
    Log('getPursueOrderDetail err:', err)
    throw err
  }
}

/** pursue-order/refund-after-clearing
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.clearing_config_id
 * @param {*} data.money
*/
export async function pursueOrderRefundAfterClearing(data = {}) {
  Log('pursueOrderRefundAfterClearing data:', data)
  try {
    const res = await Net.http('pursue-order/refund-after-clearing', { data })
    Log('pursueOrderRefundAfterClearing res:', res)
    return res
  } catch (err) {
    Log('pursueOrderRefundAfterClearing err:', err)
    throw err
  }
}

/** pursue-order/manual-clearing-order
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.order_type
*/
export async function pursueOrderManualClearing(data = {}) {
  Log('pursueOrderManualClearing data:', data)
  try {
    const res = await Net.http('pursue-order/manual-clearing-order', { data })
    Log('pursueOrderManualClearing res:', res)
    return res
  } catch (err) {
    Log('pursueOrderManualClearing err:', err)
    throw err
  }
}

/** pursue-order/batch-manual-clearing-order
 * @param {Object} data
 * @param {*} data.order_ids
 * @param {*} data.order_type
*/
export async function pursueOrderBatchManualClearing(data = {}) {
  Log('pursueOrderBatchManualClearing data:', data)
  try {
    const res = await Net.http('pursue-order/batch-manual-clearing-order', { data })
    Log('pursueOrderBatchManualClearing res:', res)
    return res
  } catch (err) {
    Log('pursueOrderBatchManualClearing err:', err)
    throw err
  }
}

/** pursue-order/power-occupy-order-list
 * @param {Object} data
 * @param {*} data.socket_uid
 * @param {*} data.gateway_uid
 * @param {*} data.nickname
 * @param {*} data.user_phone
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.clearing_begin_time
 * @param {*} data.clearing_end_time
 * @param {*} data.user_id
 * @param {*} data.sn
 * @param {*} data.page
 * @param {*} data.type
 * @param {*} data.pay_method
 * @param {*} data.status
 * @param {*} data.clearing_status
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.outer_sn
 * @param {*} data.occupy_order_sn
 * @param {*} data.refund_status
*/
export async function pursueOrderPowerOccupyOrderList(data = {}) {
  Log('pursueOrderPowerOccupyOrderList data:', data)
  try {
    const res = await Net.http('pursue-order/power-occupy-order-list', { data })
    Log('pursueOrderPowerOccupyOrderList res:', res)
    return res
  } catch (err) {
    Log('pursueOrderPowerOccupyOrderList err:', err)
    throw err
  }
}


/** === CabinetOrder === **/
/** exchange-order/list
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.page
 * @param {*} data.sn
 * @param {*} data.phone
 * @param {*} data.operator_id
 * @param {*} data.status
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getCabinetOrderList(data = {}) {
  Log('getCabinetOrderList data:', data)
  try {
    const res = await Net.http('exchange-order/list', { data })
    Log('getCabinetOrderList res:', res)
    return res
  } catch (err) {
    Log('getCabinetOrderList err:', err)
    throw err
  }
}

/** exchange-order/detail
 * @param {Object} data
 * @param {*} data.sn
*/
export async function getCabinetOrderDetail(data = {}) {
  Log('getCabinetOrderDetail data:', data)
  try {
    const res = await Net.http('exchange-order/detail', { data })
    Log('getCabinetOrderDetail res:', res)
    return res
  } catch (err) {
    Log('getCabinetOrderDetail err:', err)
    throw err
  }
}

/** exchange-order/manual-clearing-order
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.order_type
*/
export async function cabinetOrderManualClearing(data = {}) {
  Log('cabinetOrderManualClearing data:', data)
  try {
    const res = await Net.http('exchange-order/manual-clearing-order', { data })
    Log('cabinetOrderManualClearing res:', res)
    return res
  } catch (err) {
    Log('cabinetOrderManualClearing err:', err)
    throw err
  }
}


/** === CabinetPackage === **/
/** exchange-package/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.phone
 * @param {*} data.operator_id
 * @param {*} data.status
*/
export async function getCabinetPackageList(data = {}) {
  Log('getCabinetPackageList data:', data)
  try {
    const res = await Net.http('exchange-package/list', { data })
    Log('getCabinetPackageList res:', res)
    return res
  } catch (err) {
    Log('getCabinetPackageList err:', err)
    throw err
  }
}

/** exchange-package/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getCabinetPackageDetail(data = {}) {
  Log('getCabinetPackageDetail data:', data)
  try {
    const res = await Net.http('exchange-package/detail', { data })
    Log('getCabinetPackageDetail res:', res)
    return res
  } catch (err) {
    Log('getCabinetPackageDetail err:', err)
    throw err
  }
}

/** user-exchange-record/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.exchange_package_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function cabinetPackageLogList(data = {}) {
  Log('cabinetPackageLogList data:', data)
  try {
    const res = await Net.http('user-exchange-record/list', { data })
    Log('cabinetPackageLogList res:', res)
    return res
  } catch (err) {
    Log('cabinetPackageLogList err:', err)
    throw err
  }
}

/** user-exchange-record/detail-by-uid
 * @param {Object} data
 * @param {*} data.uid
*/
export async function cabinetPackageLogDetail(data = {}) {
  Log('cabinetPackageLogDetail data:', data)
  try {
    const res = await Net.http('user-exchange-record/detail-by-uid', { data })
    Log('cabinetPackageLogDetail res:', res)
    return res
  } catch (err) {
    Log('cabinetPackageLogDetail err:', err)
    throw err
  }
}

/** user-exchange-record/update-status
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.status
*/
export async function updateCabinetPackageStatus(data = {}) {
  Log('updateCabinetPackageStatus data:', data)
  try {
    const res = await Net.http('user-exchange-record/update-status', { data })
    Log('updateCabinetPackageStatus res:', res)
    return res
  } catch (err) {
    Log('updateCabinetPackageStatus err:', err)
    throw err
  }
}


/** === ClearingOrder === **/
/** clearing-order/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.status
 * @param {*} data.target_type
 * @param {*} data.target_clearing_time_begin
 * @param {*} data.target_clearing_time_end
 * @param {*} data.create_time_begin
 * @param {*} data.create_time_end
*/
export async function getClearingOrderList(data = {}) {
  Log('getClearingOrderList data:', data)
  try {
    const res = await Net.http('clearing-order/list', { data })
    Log('getClearingOrderList res:', res)
    return res
  } catch (err) {
    Log('getClearingOrderList err:', err)
    throw err
  }
}


/** === MoneyHistory === **/
/** pay/paging
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.target_id
 * @param {*} data.target_type
*/
export async function getMoneyHistoryList(data = {}) {
  Log('getMoneyHistoryList data:', data)
  try {
    const res = await Net.http('pay/paging', { data })
    Log('getMoneyHistoryList res:', res)
    return res
  } catch (err) {
    Log('getMoneyHistoryList err:', err)
    throw err
  }
}

/** pay/list-by-power
 * @param {Object} data
 * @param {*} data.target_id
*/
export async function getMoneyHistoryListByPower(data = {}) {
  Log('getMoneyHistoryListByPower data:', data)
  try {
    const res = await Net.http('pay/list-by-power', { data })
    Log('getMoneyHistoryListByPower res:', res)
    return res
  } catch (err) {
    Log('getMoneyHistoryListByPower err:', err)
    throw err
  }
}


/** === ClearingTrade === **/
/** clearing-trade/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.status
 * @param {*} data.target_pay_time_begin
 * @param {*} data.target_pay_time_end
*/
export async function getClearingTradeList(data = {}) {
  Log('getClearingTradeList data:', data)
  try {
    const res = await Net.http('clearing-trade/list', { data })
    Log('getClearingTradeList res:', res)
    return res
  } catch (err) {
    Log('getClearingTradeList err:', err)
    throw err
  }
}

/** clearing-trade/detail
 * @param {Object} data
 * @param {*} data.clearing_trade_id
*/
export async function getClearingTradeDetail(data = {}) {
  Log('getClearingTradeDetail data:', data)
  try {
    const res = await Net.http('clearing-trade/detail', { data })
    Log('getClearingTradeDetail res:', res)
    return res
  } catch (err) {
    Log('getClearingTradeDetail err:', err)
    throw err
  }
}

/** clearing-trade/check
 * @param {Object} data
 * @param {*} data.clearing_trade_id
*/
export async function checkClearingTrade(data = {}) {
  Log('checkClearingTrade data:', data)
  try {
    const res = await Net.http('clearing-trade/check', { data })
    Log('checkClearingTrade res:', res)
    return res
  } catch (err) {
    Log('checkClearingTrade err:', err)
    throw err
  }
}

/** clearing-trade/wait-list
 * @param {Object} data
 * @param {*} data.target_pay_time_begin
 * @param {*} data.target_pay_time_end
 * @param {*} data.page
*/
export async function clearingTradeWaitList(data = {}) {
  Log('clearingTradeWaitList data:', data)
  try {
    const res = await Net.http('clearing-trade/wait-list', { data })
    Log('clearingTradeWaitList res:', res)
    return res
  } catch (err) {
    Log('clearingTradeWaitList err:', err)
    throw err
  }
}

/** clearing-trade/update-trade-account-pay-config
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.alipay_account_id
 * @param {*} data.alipay_real_name
*/
export async function updateClearingTradeTradeAccountPayConfig(data = {}) {
  Log('updateClearingTradeTradeAccountPayConfig data:', data)
  try {
    const res = await Net.http('clearing-trade/update-trade-account-pay-config', { data })
    Log('updateClearingTradeTradeAccountPayConfig res:', res)
    return res
  } catch (err) {
    Log('updateClearingTradeTradeAccountPayConfig err:', err)
    throw err
  }
}


/** === ClearingTradeItem === **/
/** clearing-trade-item/list
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.target_pay_time_begin
 * @param {*} data.target_pay_time_end
 * @param {*} data.create_time_begin
 * @param {*} data.create_time_end
 * @param {*} data.status
 * @param {*} data.subject
 * @param {*} data.page
*/
export async function getClearingTradeItemList(data = {}) {
  Log('getClearingTradeItemList data:', data)
  try {
    const res = await Net.http('clearing-trade-item/list', { data })
    Log('getClearingTradeItemList res:', res)
    return res
  } catch (err) {
    Log('getClearingTradeItemList err:', err)
    throw err
  }
}

/** clearing-trade-item/list-by-order-id
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.type
*/
export async function getClearingTradeItemListByOrderId(data = {}) {
  Log('getClearingTradeItemListByOrderId data:', data)
  try {
    const res = await Net.http('clearing-trade-item/list-by-order-id', { data })
    Log('getClearingTradeItemListByOrderId res:', res)
    return res
  } catch (err) {
    Log('getClearingTradeItemListByOrderId err:', err)
    throw err
  }
}

/** clearing-trade-item/list-by-clearing-trade-id
 * @param {Object} data
 * @param {*} data.clearing_trade_id
 * @param {*} data.page
*/
export async function getClearingTradeItemListByClearingTradeId(data = {}) {
  Log('getClearingTradeItemListByClearingTradeId data:', data)
  try {
    const res = await Net.http('clearing-trade-item/list-by-clearing-trade-id', { data })
    Log('getClearingTradeItemListByClearingTradeId res:', res)
    return res
  } catch (err) {
    Log('getClearingTradeItemListByClearingTradeId err:', err)
    throw err
  }
}

/** clearing-order/sub-order/list
 * @param {Object} data
 * @param {*} data.order_id
 * @param {*} data.order_type
*/
export async function getClearingTradeItemSubRecord(data = {}) {
  Log('getClearingTradeItemSubRecord data:', data)
  try {
    const res = await Net.http('clearing-order/sub-order/list', { data })
    Log('getClearingTradeItemSubRecord res:', res)
    return res
  } catch (err) {
    Log('getClearingTradeItemSubRecord err:', err)
    throw err
  }
}
